<div class="p-6 bg-gray-100 relative rounded shadow">
  <button
    (click)="close()"
    type="button"
    class="absolute top-3 right-3 focus:outline-none p-2"
  >
    <fa-icon [icon]="faClose"></fa-icon>
  </button>
  <div class="flex space-x-2 mb-5">
    <fa-icon class="text-gray-800" [icon]="faCheckToSlot"></fa-icon>
    <div class="flex flex-col">
      <h3 class="text-lg font-semibold text-gray-800">{{ todo.title }}</h3>
      <p class="text-sm text-gray-500">in list ToDo</p>
    </div>
  </div>
  <div class="flex w-full gap-4">
    <div class="flex space-x-2 mb-5 w-4/6">
      <fa-icon class="text-gray-800" [icon]="faBars"></fa-icon>
      <div class="flex flex-col">
        <h3 class="text-lg font-semibold text-gray-800">Description</h3>
        <p class="text-sm text-gray-500">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis,
          hic? Adipisci soluta cum odio, beatae ratione magni nobis, optio
          similique rerum minus excepturi sed vel, id voluptatibus repellendus
          numquam quod.
        </p>
        <div class="space-x-2 flex float-left">
          <button type="button" (click)="closeWithRta(true)">SI</button>
          <button type="button" (click)="closeWithRta(false)">NO</button>
        </div>
      </div>
    </div>
    <div class="flex flex-auto space-y-2 flex-col">
      <app-btn typeBtn="button" color="light">
      <span class="flex space-x-2 text-left">
        <fa-icon class="text-gray-800" [icon]="faUser"></fa-icon>
        <span> Members</span>
      </span>
      </app-btn>
      <app-btn typeBtn="button" color="light">
      <span class="flex space-x-2 text-left">
        <fa-icon class="text-gray-800" [icon]="faTag"></fa-icon>
        <span>Labels</span>
        </span>
      </app-btn>
      <app-btn typeBtn="button" color="light">
      <span class="flex space-x-2 text-left">
        <fa-icon class="text-gray-800" [icon]="faCheckSquare"></fa-icon>
        <span> Checklist</span>
        </span>
      </app-btn>
      <app-btn typeBtn="button" color="light">
      <span class="flex space-x-2 text-left">
        <fa-icon class="text-gray-800" [icon]="faClock"></fa-icon>
        <span> Dates </span>
        </span>
      </app-btn>
    </div>
  </div>
</div>
